import type { PermissionsScope } from '../../core';
import type { PermissionsScope as ServiceScope } from 'store/apis/permissionsApi';

/**
 * The port's scope in the shape the query takes.
 *
 * The organisation id is stringified here rather than at the slice, because `domain/Organization`
 * holds it as a `number` while the query argument is `string`-only on purpose: RTK Query derives
 * its cache key from the serialised argument, so `1` and `'1'` would be two entries and two
 * requests for one scope.
 *
 * Shared by the hook and the state-form selector so the two cannot key the same scope differently -
 * which would have the thunk awaiting one cache entry and then reading another.
 */
export const toServiceScope = (scope: PermissionsScope): ServiceScope =>
  scope.organisationId !== undefined
    ? { kind: 'organisation', organisationId: String(scope.organisationId) }
    : { kind: 'community', communityId: scope.communityId };
